<body class="mainDiv">
    <div class="mainHeadingDiv flex-row end-center">
        <label class="mainHeading">Rankings</label>
        <button mat-icon-button class="heading-close" (click)="onCloseClick()">
            <mat-icon>clear</mat-icon>
        </button>
    </div>

    <div class="mainHeadingDiv2 flex-row center-center">
        <label class="mainHeading2">{{ activeSeason }} {{ 'PRIORITY-GROUPS.SEASON' | translate }} | {{cropType}}</label>
    </div>
    <div class="scrollable">
        <div *ngFor="let ranking of rankings" class="priority-item" [ngClass]="{'active-priority-item': ranking.id === activeId, 'priority-item': ranking.id !== activeId }">
            <div class="priority-heading-container flex-row space-between-center" (click)="rankingClick(ranking)">
                <label class="label-small">{{ ranking.fieldName }}</label>
                <label class="priority-mainHeading">{{ ranking.farmName }}</label>
                <div class="flex-row end-center" *ngIf="getIcon(ranking) == '' ">
                    <label class="label-small-2">{{ getStatus(ranking) }}</label>
                </div>
                <div class="flex-row end-center" *ngIf="getIcon(ranking) != '' ">
                    <label class="label-small-3 icon-space">{{ getStatus(ranking) }}</label>
                    <mat-icon
                        [ngClass]="{ 'attention': getIconClass(ranking) === 'info',  'check': getIconClass(ranking) === 'check_circle' }">
                        {{ getIcon(ranking) }}</mat-icon>
                </div>
            </div>
            <div class="row-flex">
                <div class="priority-sub-heading-1 col-flex-item vertical-divider">
                    <label class="label-hover1">{{ 'PRIORITY-GROUPS.CURRENT-RANK' | translate }}</label>
                    <label class="label-hover1 number-space">{{ ranking.ranking }}</label>
                    <mat-icon class="ranking-icon"
                        [ngClass]="{ 'check': getRankingIcon(ranking) === 'arrow_upward',  'bad': getRankingIcon(ranking) === 'arrow_downward' }">
                        {{ getRankingIcon(ranking) }}</mat-icon>
                </div>
                <div class="priority-sub-heading-2 col-flex-item">
                    <label class="label-hover">{{ 'PRIORITY-GROUPS.PREVIOUS-RANK' | translate }}</label>
                    <label class="label-hover number-space">{{ ranking.previousRanking }}</label>
                </div>
            </div>
        </div>
    </div>
</body>